export type AppBrand = {
  /** 'fash' is Shahr Bank's own install; it shows MegaPay's name and logo. */
  key: 'megapay' | 'asa' | 'fash'
  name: 'معتمد آسا' | 'آسا' | 'مگاپی'
  latinName: 'ASA TSP' | 'ASA' | 'MegaPay'
  copyright: string
  apiUrl: string
  url: string
  apiRoot: string
  website: string
  /** The bank's own install manifest; the other brands keep the one their page names. */
  manifest?: string
  /** A brand's own logo (the mark with the name), square mark and icons; the others keep ASA's files. */
  logo?: string
  mark?: string
  favicon?: string
  appleTouchIcon?: string
  /** The installed app's icon, as the install offers show it. */
  appIcon?: string
  /** The demo install: sample data, and nothing real leaves it. */
  isDemo?: boolean
}

const defaultBrand: AppBrand = {
  key: 'megapay',
  name: 'معتمد آسا',
  latinName: 'ASA TSP',
  copyright: '© کلیه حقوق متعلق به شرکت ارتباطات فراهوشمند تیوا می باشد.',
  apiUrl: 'https://api.mega-pay.ir/api',
  url: 'https://cp.mega-pay.ir/api',
  apiRoot: 'https://api.mega-pay.ir',
  website: 'https://mega-pay.ir',
}

const runtimeBranding = typeof window === 'undefined' ? undefined : window.__MEGAPAY_BRANDING__

const getBrandForHostname = (hostname: string): AppBrand =>
  runtimeBranding?.getBrandForHostname(hostname) ?? defaultBrand

const currentHostname = typeof window === 'undefined' ? '' : window.location.hostname

const currentBrand = getBrandForHostname(currentHostname)

// Every panel domain is served by the same build, so the POS app is chosen by host name: a panel
// opened on a subdomain whose first label starts with "pos" (pos.mphub.ir, pos2.asatsp.ir, …)
// behaves as a build with REACT_APP_MEGAPAY_isPOS=true did.
const isPosHostname = (hostname: string) =>
  String(hostname || '')
    .trim()
    .toLowerCase()
    .split('.')[0]
    .startsWith('pos')

const isPosHost = isPosHostname(currentHostname)
const isDemoInstall = Boolean(currentBrand.isDemo)
const brandName = currentBrand.name
const brandCopyright = currentBrand.copyright
const brandApiUrl = currentBrand.apiUrl
const brandUrl = currentBrand.url
const brandApiRoot = currentBrand.apiRoot
const brandWebsite = currentBrand.website

const hasMegaPayBusinessCapabilities = (brand: AppBrand = currentBrand) =>
  brand.key === 'megapay' || brand.key === 'asa'

// Since 2026-09-30 every cp.mega-pay.ir visitor is moved to my.asatsp.ir, so the ASA brand has to
// offer the automatic-invoice Excel tab too; a megapay-only rule hid it from every customer.
const hasAutomaticInvoiceCapability = (brand: AppBrand = currentBrand) =>
  brand.key === 'megapay' || brand.key === 'asa'

export {
  brandApiRoot,
  brandApiUrl,
  brandCopyright,
  brandName,
  brandUrl,
  brandWebsite,
  currentBrand,
  getBrandForHostname,
  hasAutomaticInvoiceCapability,
  hasMegaPayBusinessCapabilities,
  isDemoInstall,
  isPosHost,
  isPosHostname,
}
